<div class="card shadow mb-4 bloque-5">
  <!-- Card Header - Dropdown -->
  <div
    class="card-header py-3 d-flex flex-row align-items-center justify-content-between"
  >
    <h6 class="m-0 font-weight-bold text-secondary">
      {{ title }}
    </h6>
    <div class="dropdown no-arrow">
      <a
        class="dropdown-toggle"
        href="#"
        role="button"
        id="dropdownMenuLink"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <i class="fas fa-ellipsis-v fa-sm fa-fw text-gray-400"></i>
      </a>
      <div
        class="dropdown-menu dropdown-menu-right shadow animated--fade-in"
        aria-labelledby="dropdownMenuLink"
      >
        <div class="dropdown-header">Dropdown Header:</div>
        <a class="dropdown-item" href="#">Action</a>
        <a class="dropdown-item" href="#">Another action</a>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item" href="#">Something else here</a>
      </div>
    </div>
  </div>
  <!-- Card Body -->
  <div>
    <p-chart type="line" [data]="data" [options]="options" *ngIf="!isLoading"/>
    <div class="p-3">
      <p-skeleton height="465px" *ngIf="isLoading" />
    </div>
  </div>
</div>
